import { ContainedIcon } from '@frontend/icons';
import { AiWarn, AiCritical, AiAssistant, AiTransferred } from '@frontend/styled-icons';
import { theme } from '@frontend/theme';
import { WithTooltip } from './common';

export const AiWarnWithTooltip = ({ tooltipText }: { tooltipText?: string }) => {
  return (
    <WithTooltip tooltipText={tooltipText}>
      <AiWarn />
    </WithTooltip>
  );
};

export const AiCriticalWithTooltip = ({ tooltipText }: { tooltipText?: string }) => {
  return (
    <WithTooltip tooltipText={tooltipText}>
      <AiCritical />
    </WithTooltip>
  );
};

export const AiTransferredWithTooltip = ({ tooltipText }: { tooltipText?: string }) => {
  return (
    <WithTooltip tooltipText={tooltipText}>
      <AiTransferred />
    </WithTooltip>
  );
};

export const AiSuccess = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,

        color: theme.colors.success50,
        width: 16,
        height: 16,
        svg: {
          width: '100%',
          height: '100%',
        },
      }}
      iconName='check'
    />
  );
};

export const AiSuccessWithTooltip = ({ tooltipText }: { tooltipText?: string }) => {
  return (
    <WithTooltip tooltipText={tooltipText}>
      <AiSuccess />
    </WithTooltip>
  );
};

export const AiAssistantWithTooltip = ({ tooltipText }: { tooltipText?: string }) => {
  return (
    <WithTooltip tooltipText={tooltipText}>
      <AiAssistant />
    </WithTooltip>
  );
};

export const AiQuestion = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: theme.borderRadius.small,
      }}
      iconName='info' // TODO: replace with question icon when available, we don't currently have one
      color={theme.colors.neutral70}
      background={theme.colors.neutral10}
    />
  );
};

export const AiQuestionWithTooltip = ({ tooltipText }: { tooltipText?: string }) => {
  return (
    <WithTooltip tooltipText={tooltipText}>
      <AiQuestion />
    </WithTooltip>
  );
};
